
import { Component, Vue, Prop, InjectReactive } from "vue-property-decorator"
import { TreeNode } from "@/types"

@Component({
	components: {
		tree: () => import("./Tree.vue")
	}
})
export default class Tree extends Vue {
	@InjectReactive("treeVisibility") visibility!: { [key: string]: boolean }

	@Prop()
	item!: TreeNode<any>;

	@Prop()
	setActiveItem!: (ItemId: string) => void;

	@Prop()
	itemSelected!: (item: any) => void;

	@Prop()
	addItem!: (item: any) => void;

	@Prop()
	activeItemId!: string;

	@Prop({ type: Boolean, default: true })
	showAddNewButton: boolean = true;

	childrenExpanded: boolean = true;

	private get itemVisible (): boolean {
		return this.item && this.item.node && this.visibility && this.visibility[this.item.node.id]
	}

	private selected (item: any) {
		this.itemSelected(item)
	}

	private add (item: any) {
		this.addItem(item)
	}

	private changeVisiblity (item: TreeNode<any>) {
		if (item.children != null && item.children.length > 0) {
			if (item.children[0].visible === undefined || item.children[0].visible === false) {
				item.children.forEach(item => item.visible = true)
			} else {
				item.children.forEach(item => item.visible = false)
				this.closeAllHierarchyChildren(item)
			}
		}
	}

	public isOpen () : boolean {
		if (this.item.children != null && this.item.children.length > 0) {
			if (this.item.children[0].visible === undefined || this.item.children[0].visible === false) {
				return false
			} else {
				return true
			}
		}

		return false
	}

	public closeAllHierarchyChildren (item: TreeNode<any>) {
		if (item.children != null && item.children.length > 0) {
			if (item.children[0].visible !== undefined) {
				item.children.forEach(item => {
					item.visible = false
					this.closeAllHierarchyChildren(item)
				})
			}
		}
	}
}
